import OrganizationUserCreate from './OrganizationUserCreate'
import OrganizationUserEdit from './OrganizationUserEdit'

export default {
  create: OrganizationUserCreate,
  edit: OrganizationUserEdit,
}
